<template>
  <div class="data-log">
    <div class="filter-wrap">
      <common-select
        label="全部时间"
        type="time"
        @select="filterLog($event, 'dates')"
      ></common-select>
      <common-select
        label="所有人"
        :options="operatorOptions"
        @select="filterLog($event ? [$event] : [], 'op')"
      ></common-select>
      <common-select
        :options="typeOptions"
        @select="filterLog($event ? [$event] : [], 'types')"
      ></common-select>
    </div>
    <div v-ps class="log-list">
      <div class="log-item font-main" v-for="(log, index) in filteredLogs" :key="index">
        <div class="log-time">{{ log.time }}</div>
        <div class="log-content">
          <staff-popover :staffId="log.creator.id">
            <template v-slot:reference>
              <el-tooltip
                :content="log.creator.name || '无'"
                placement="top"
                :disabled="!log.creator.id || log.creator.id.length > 3"
              >
                <staff-avatar class="avatar" :size="30" :user="log.creator"></staff-avatar>
              </el-tooltip>
            </template>
          </staff-popover>
          <div class="log-text">
            <div class="log-title">{{ log.title }}</div>
            <div v-if="log.type === 'VERIFY'">
              <div v-html="log.extra" v-viewer="{ backdrop: 'static' }"></div>
            </div>
            <div v-else-if="log.detail && log.detail.length">
              <div v-for="(item, index) in log.detail" :key="index">
                <div v-if="item.ctrlType === 'rich'" v-viewer="{ backdrop: 'static' }">
                  {{ item.ctrlName }}：
                  <div v-html="item.oldStr"></div>
                  ->
                  <div v-html="item.newStr"></div>
                </div>
                <div v-else-if="item.ctrlType === 'file'">
                  {{ item.ctrlName }}：
                  <a
                    :class="item.oldExt ? 'external-link pointer' : ''"
                    @click="item.oldExt && download(item.oldExt, oldStr)"
                  >
                    {{ item.oldStr }}
                  </a>
                  ->
                  <a
                    :class="item.newExt ? 'external-link pointer' : ''"
                    @click="item.newExt && download(item.newExt, newStr)"
                  >
                    {{ item.newStr }}
                  </a>
                  <br />
                </div>
                <div v-else>{{ item.ctrlName }}： {{ item.oldStr }} -> {{ item.newStr }}</div>
              </div>
            </div>
            <div v-else>
              <div v-for="(item, index) in log.content" :key="index">
                {{ item }}
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTaskLogList } from "@/api/project/task"
import CommonSelect from "@/components/UIComponents/CommonSelect"
import dj from "dayjs"
import { signature } from "@/utils/aliOss"
import { loadingService } from "@/utils/ui"
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "DataLog",
  props: {
    taskId: {
      type: String,
      required: true
    }
  },
  components: {
    StaffAvatar,
    CommonSelect,
    StaffPopover
  },
  watch: {
    taskId: {
      handler() {
        this.init()
      },
      immediate: true
    }
  },
  data() {
    return {
      logSearchBody: {
        types: [],
        op: [],
        dates: null
      },
      typeOptions: [
        {
          value: "user",
          label: "用户操作"
        },
        {
          value: "sys",
          label: "系统操作"
        },
        {
          value: "verify",
          label: "审批"
        }
      ],
      type: "all",
      logs: [],
      filteredLogs: []
    }
  },
  computed: {
    operatorOptions() {
      let res = {}
      this.logs.forEach(log => {
        let id = log.creatorId
        res[id] = {
          value: id,
          label: log.creator.name
        }
      })
      return Object.values(res)
    }
  },
  methods: {
    init() {
      let logTitleMap = {
        CREATE: "【创建】了任务",
        REDO: "【重启】了任务",
        COMPLETE: "【填写并完成】了任务",
        COMPLETE_SAVE_ONLY: "【仅保存】了任务",
        COMPLETE_ONLY: "【完成】了任务",
        UPDATE: "【编辑】了任务",
        DELETE: "【删除】了任务",
        VERIFY: "【审批】了任务",
        ASSIGNEE: "【更改】了负责人",
        PARTICIPANTS: "【更改】了参与人",
        CHANGE_PARENT: "【更改】了父任务",
        CHANGE_CANDIDATES: "【更改】了审批人",
        RECALL: "【撤回】了审批"

        // LOCK: "【锁定】了任务",
        // UNLOCK: "【解锁】了任务",
        // PRINT: "【打印】了任务",
        // FILL: "【填写】了任务",
        // BUTTON: "触发了按钮"
      }
      // 获取log
      getTaskLogList(this.taskId).then(logs => {
        logs = logs.map(log => {
          switch (log.type) {
            case "BUTTON":
              log.title = "【" + log.subTitle + "】了任务"
              break
            default:
              log.title = logTitleMap[log.type]
          }
          log.time = log.createAt.replace(" ", "\n")
          log.content = (log.extra ? log.extra.split(";") : []).filter(t => Boolean(t))
          return log
        })
        logs.reverse()
        this.logs = logs
        this.filterLog()
      })
    },
    download(path, name) {
      const loadingInstance = loadingService()
      signature({ objectName: path, downloadName: name }).then(res => {
        loadingInstance.close()
        window.open(res)
      })
    },
    filterLog(value, type) {
      this.logSearchBody[type] = value
      let searchBody = this.logSearchBody
      let isBetween = require("dayjs/plugin/isBetween")
      dj.extend(isBetween)
      this.filteredLogs = this.logs.filter(log => {
        // 时间
        if (
          searchBody.dates &&
          log.createAt &&
          !dj(log.createAt).isBetween(searchBody.dates[0], searchBody.dates[1])
        ) {
          return false
        }
        // 操作人
        if (searchBody.op.length && !searchBody.op.includes(log.creatorId)) {
          return false
        }
        // 类型 最后一个判断
        if (searchBody.types.length) {
          for (let type of searchBody.types) {
            switch (type) {
              case "sys":
                if (log.creatorId.length < 24) {
                  return true
                }
                break
              case "user":
                if (log.creatorId.length === 24) {
                  return true
                }
                break
              case "verify":
                if (["VERIFY", "RECALL", "CHANGE_CANDIDATES"].includes(log.type)) {
                  return true
                }
                break
            }
          }
          return false
        }
        return true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.data-log {
  height: 100%;
  display: flex;
  flex-flow: column;
  padding-right: 56px;
  padding-bottom: 60px;
  .log-filter {
    margin-top: 23px;
  }
  .filter-wrap {
    display: flex;
    .common-select {
      margin-right: 20px;
    }
  }
  .log-list {
    flex: auto;
    display: flex;
    flex-direction: column;
    margin-top: 17px;
    .log-item {
      display: flex;
      .log-time {
        flex-shrink: 0;
        text-align: right;
        white-space: pre;
        padding-right: 13px;
      }
      .log-content {
        display: flex;
        padding: 0 10px 30px 13px;
        border-left: 2px solid $color-bg-home;
        .avatar {
          flex-shrink: 0;
        }
        .log-text {
          .log-title {
            margin-left: -8px;
            line-height: 25px;
          }
          .external-link {
            color: $color-main;
          }
          margin-left: 15px;
        }
      }
    }
  }
}
</style>
